import { render, staticRenderFns } from "./ProtectionOfConfidentialInfoModal.vue?vue&type=template&id=e8bcce42&scoped=true"
import script from "./ProtectionOfConfidentialInfoModal.vue?vue&type=script&lang=ts"
export * from "./ProtectionOfConfidentialInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bcce42",
  null
  
)

export default component.exports